var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClinicLogo = function SvgClinicLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "07.-Minc-Admin",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "New-Menu",
    transform: "translate(-480.000000, -302.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Component-/-Navigation-Bar-/-Clinic",
    transform: "translate(460.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clinic-List",
    transform: "translate(0.000000, 289.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Text-Fill",
    transform: "translate(20.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon_Left",
    transform: "translate(0.000000, 13.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16,2 C16.5522847,2 17,2.44771525 17,3 L17,22 L14,22 L14,18 C14,17.7545401 13.8231248,17.5503916 13.5898756,17.5080557 L13.5,17.5 L10.5,17.5 C10.2545401,17.5 10.0503916,17.6768752 10.0080557,17.9101244 L10,18 L10,22 L7,22 L7,3 C7,2.44771525 7.44771525,2 8,2 L16,2 Z M5.5,13 C5.77614237,13 6,13.2238576 6,13.5 L6,22 L2,22 L2,13.5 C2,13.2238576 2.22385763,13 2.5,13 L5.5,13 Z M21.5,13 C21.7761424,13 22,13.2238576 22,13.5 L22,22 L18,22 L18,13.5 C18,13.2238576 18.2238576,13 18.5,13 L21.5,13 Z M5,17 L3,17 L3,19 L5,19 L5,17 Z M21,17 L19,17 L19,19 L21,19 L21,17 Z M5,14 L3,14 L3,16 L5,16 L5,14 Z M21,14 L19,14 L19,16 L21,16 L21,14 Z M11.25,12.5 L9.25,12.5 L9.25,14.5 L11.25,14.5 L11.25,12.5 Z M14.75,12.5 L12.75,12.5 L12.75,14.5 L14.75,14.5 L14.75,12.5 Z M15.25,3.5 L8.75,3.5 L8.75,10.5 L15.25,10.5 L15.25,3.5 Z M12,4.5 C12.4142136,4.5 12.75,4.83578644 12.75,5.25 L12.75,6.249 L13.75,6.25 C14.1642136,6.25 14.5,6.58578644 14.5,7 C14.5,7.41421356 14.1642136,7.75 13.75,7.75 L12.75,7.75 L12.75,8.75 C12.75,9.16421356 12.4142136,9.5 12,9.5 C11.5857864,9.5 11.25,9.16421356 11.25,8.75 L11.25,7.75 L10.25,7.75 C9.83578644,7.75 9.5,7.41421356 9.5,7 C9.5,6.58578644 9.83578644,6.25 10.25,6.25 L11.25,6.25 L11.25,5.25 C11.25,4.83578644 11.5857864,4.5 12,4.5 Z",
    id: "Combined-Shape",
    fill: "#F6F7FA"
  })))))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClinicLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clinic-logo.265a8a2f.svg";
export { ForwardRef as ReactComponent };